import React, { useLayoutEffect } from "react";
import JoinGame from "./JoinGame";
import Authorized from "../Authorized";
import AuthService from "../../utils/AuthService";

function Gameroom({ setShowAppBar }) {
  // Hide AppBar when this page mounts
  useLayoutEffect(() => {
    setShowAppBar(false);
    return () => {
      setShowAppBar(true);
    };
  }, [setShowAppBar]);
  if (!AuthService.isLoggedIn()) {
    if (AuthService.isFaculty()) {
      return <Authorized refRoute="Courses" />;
    }
    return <Authorized refRoute="Gameroom" />;
  }

  // If logged in & student → show JoinGame
  return <JoinGame />;
}

export default Gameroom;
